import type { TourProps } from 'antd'

// First-usage steps for a new salesman or company. Targets are resolved lazily
// and may return null — antd's Tour then renders that step centered, so the
// tour degrades gracefully when an anchor is not mounted (collapsed sider,
// mobile drawer). Deliberately short: four steps, no FAQ, no external pages.
type TourTarget = NonNullable<TourProps['steps']>[number]['target']

const anchor = (selector: string): TourTarget =>
  (() => document.querySelector<HTMLElement>(selector)) as TourTarget

export const buildOnboardingSteps = (): TourProps['steps'] => [
  {
    title: 'Bienvenue sur Autoriz 👋',
    description:
      "Voici un rapide tour d'horizon pour prendre en main votre espace. Cela ne prend qu'une minute.",
  },
  {
    title: 'Votre menu',
    description:
      "Retrouvez ici vos projets, vos études urbaines et vos clients — tout est accessible depuis ce menu.",
    target: anchor('.ant-layout-sider'),
    placement: 'right',
  },
  {
    title: 'Démarrer une demande',
    description:
      "Lancez un nouveau dossier en un clic grâce à ce bouton. Vous serez guidé à chaque étape.",
    target: anchor('[data-cy="action--new-request"]'),
    placement: 'right',
  },
  {
    title: "C'est parti !",
    description:
      "Vous êtes prêt à travailler sur vos dossiers. Bon courage !",
  },
]
